import { createSlice } from '@reduxjs/toolkit'

import { IpMappingRead } from 'common/api/v1/types'
import { isOneOf } from '../actions'
import {
  clearEditMapping,
  removeIpMapping,
  removeIpMappings,
  createIpMapping,
  getIpMapping,
  updateIpMapping,
} from '../actions/addressMappingActions'

import { logoutUser } from '../actions/userActions'
import { createLoadingReducer } from './shared'

interface State {
  loading: boolean
  saving?: boolean
  ipMapping?: IpMappingRead
}
export const initialStateAddressMapping: State = {
  loading: false,
}

const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(
  createIpMapping,
  updateIpMapping,
  removeIpMapping,
  removeIpMappings,
  getIpMapping,
)

const addressMappingSlice = createSlice({
  name: 'addressMappings',
  initialState: initialStateAddressMapping,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(logoutUser.fulfilled, (): State => initialStateAddressMapping)
      .addCase(clearEditMapping, (state): State => ({ ...state, ipMapping: undefined }))
      .addCase(
        getIpMapping.fulfilled,
        (state, { payload: mapping }): State => ({
          ...state,
          ipMapping: mapping,
        }),
      )
      .addMatcher(
        isOneOf([updateIpMapping.pending, removeIpMapping.pending, removeIpMappings.pending]),
        (state): State => ({ ...state, saving: true }),
      )
      .addMatcher(
        isOneOf([
          updateIpMapping.fulfilled,
          updateIpMapping.rejected,
          removeIpMapping.fulfilled,
          removeIpMapping.rejected,
          removeIpMappings.fulfilled,
          removeIpMappings.rejected,
        ]),
        (state): State => ({
          ...state,
          saving: undefined,
        }),
      )
      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default addressMappingSlice.reducer
